export const LEASING_CALCULATOR_CONFIG = {
    leaseTermMonths: 36,
    privateUseRate: 0.0025 , // 0.25% Monatlich
    protectionPackage: 0.003, // 0.3% Monatlich
    provider: {
        'jobrad':  {
            name: 'JobRad',
            service_fee: {
                min: 0.055,
                max: 0.07,
            }
        }
    }
}